import { supabase } from "@/integrations/supabase/client";
import { useState } from "react";

export function useUpload() {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState<string | null>(null);

  const uploadImage = async (file: File, bucketName: string = 'expert-uploads') => {
    try {
      setIsUploading(true);
      setUploadError(null);

      console.log(`Uploading to bucket: ${bucketName}`);
      console.log('File details:', {
        name: file.name,
        size: file.size,
        type: file.type
      });

      // Generate a unique filename
      const fileExt = file.name.split('.').pop();
      const fileName = `${crypto.randomUUID()}.${fileExt}`;
      const filePath = `${fileName}`;

      console.log('Generated file path:', filePath);

      // Upload to Supabase storage
      const { data, error } = await supabase.storage
        .from(bucketName)
        .upload(filePath, file);

      if (error) {
        console.error('Supabase upload error:', error);
        setUploadError(error.message);
        return null;
      }

      console.log('Upload successful, getting public URL...');

      // Get the public URL
      const { data: { publicUrl } } = supabase.storage
        .from(bucketName)
        .getPublicUrl(filePath);

      console.log('Public URL generated:', publicUrl);

      return {
        url: publicUrl,
        path: filePath,
        fileName: fileName
      };
    } catch (err) {
      console.error('Upload error:', err);
      setUploadError(err instanceof Error ? err.message : 'Upload failed');
      return null;
    } finally {
      setIsUploading(false);
    }
  };

  return { uploadImage, isUploading, uploadError };
}
